import "./header.scss";
import { Person, Mail } from "@material-ui/icons";

export default function Header({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
        <div className="left">
          <a href="/" className="logo">
            Siwar Samaali
          </a>
          <div className="itemContainer">
          
            <Person className="icon" />
            <span>+216 28 013 854</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>siwarsamaali7@gmail.com</span>
          </div>
        </div>
        <div className="right">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}